import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { Context } from "../context/TestContext";
import "./../assets/estilos.css"

const BarraEmoticons = () => {

    const {pregunta,puntaje, onAddPuntaje, onResetPuntaje } = useContext(Context);

    const setearPuntaje = (valor,preguntaActual) => {
        let nextPregunta = preguntaActual+1;
        onAddPuntaje(valor,nextPregunta);
    };

    return (
        <div className="iconContent">
   
            <div>
            <h4>1</h4>
            <a  onClick={() => setearPuntaje(1,pregunta)} >
            <img src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/120/twitter/282/grinning-face_1f600.png" alt="Feliz" className="iconos"></img>
            </a>
            </div>
            <div>
            <h4>2</h4>
            <img onClick={() => setearPuntaje(2,pregunta)} src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/160/twitter/282/slightly-smiling-face_1f642.png" alt="Feliz" className="iconos"></img>
            </div>
            <div>
            <h4>3</h4>
            <img onClick={() => setearPuntaje(3,pregunta)} src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/160/twitter/282/neutral-face_1f610.png" alt="Neutro" className="iconos"></img>
            </div>
            <div>
            <h4>4</h4>
            <img onClick={() => setearPuntaje(4,pregunta)} src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/160/twitter/282/slightly-frowning-face_1f641.png" alt="triste" className="iconos"></img>
            </div>
            <div>
            <h4>5</h4>
            <img onClick={() => setearPuntaje(5,pregunta)} src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/160/twitter/282/worried-face_1f61f.png" alt="muyTriste" className="iconos"></img>
            </div>
        </div>
    );
}

export default BarraEmoticons;